import { SET_LISTA_CATALOGUES, RESET_LISTA_CATALOGUES, SET_SELECTED_CATALOGUE, SET_SELECTED_CATALOGUES } from './types';

// Tenta di ottenere i cataloghi da localStorage all'inizializzazione
const savedCatalogues = localStorage.getItem("catalogues");
const initialState = {
    listaCatalogues: savedCatalogues ? JSON.parse(savedCatalogues) : [],
    selectedCatalog: { id: "all", nameCatalog: "All Catalogues" },
    selectedCatalogs: [{ id: "all", nameCatalog: "All Catalogues" }]
};

const cataloguesReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LISTA_CATALOGUES:
            return {
                ...state,
                listaCatalogues: action.payload
            };
        case RESET_LISTA_CATALOGUES:
            localStorage.removeItem("catalogues"); // Rimuovi anche da localStorage
            return {
                ...state,
                listaCatalogues: []
            };
        case SET_SELECTED_CATALOGUE:
            return {
                ...state,
                selectedCatalog: action.catalog || initialState.selectedCatalog
            };
        case SET_SELECTED_CATALOGUES:
            return {
                ...state,
                selectedCatalogs: action.catalogs || initialState.selectedCatalogs,
                // Aggiorniamo anche selectedCatalog al primo elemento della lista
                selectedCatalog: action.catalogs && action.catalogs.length > 0
                    ? action.catalogs[0]
                    : initialState.selectedCatalog
            };
        default:
            return state;
    }
};

export default cataloguesReducer; 